module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av492-8c4038724099cbdcd3c6fc565fa9e2f9.jpg";